import { computed } from 'vue'
import { useContentReviewStore } from '@/content-review/content-review.store'
import { useContentProfileStore } from '@/contentprofile/contentprofile.store'
import { useVisibilityStore } from '@/visibility/visibility.store'

export function useImpactCriteriaAttrs() {
  const contentReviewStore = useContentReviewStore()
  const contentProfileStore = useContentProfileStore()
  const visibilityStore = useVisibilityStore()

  const reviewCriteriaSetName = computed(() =>
    contentReviewStore.criteriaSetNameForContentType(
      contentProfileStore.profileId,
      'impact',
      visibilityStore.betaVisibility
    )
  )

  const criteriaEventAttrs = computed(() => {
    const profileId = contentProfileStore.profileId
    const betaMode = visibilityStore.betaVisibility

    const hasCustomProfile = !!profileId && profileId !== ''
    const customCriteria = hasCustomProfile
      ? contentReviewStore.criteriaForProfile(profileId, 'impact', betaMode)
      : []
    const isUsingCustomCriteria = hasCustomProfile && customCriteria.length > 0

    return {
      criteria_label: reviewCriteriaSetName.value || 'default',
      is_custom_criteria_set: isUsingCustomCriteria,
    }
  })

  return { reviewCriteriaSetName, criteriaEventAttrs }
}
